module.exports = __webpack_public_path__ + "img/1.65bae564.jpg";